import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateExperienceMutation as CreateExperienceMutationType,
  CreateExperienceMutationVariables,
} from "./__generated__/CreateExperienceMutation";

const CreateExperienceMutation = loader("./CreateExperienceMutation.gql");

type CreateExperienceMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateExperienceMutationType) => void;
}) => ReactElement;

export const CreateExperienceMutationProvider: CreateExperienceMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateExperienceMutationType, CreateExperienceMutationVariables>(
    CreateExperienceMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
